import '../index.css';

import { OpenAPI } from 'api-clients/monolith';
import { LanguageProvider } from 'i18n/LanguageProvider';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import { AppContextProvider } from 'components/app-context-provider';
import { FeatureFlagContextProvider } from 'components/feature-flag-context-provider';
import { domainMeta } from 'utils/domainMeta';

import { Root } from './root';

const MOUNT_NODE = document.getElementById('app');
OpenAPI.BASE = domainMeta.monolithOrigin;
OpenAPI.WITH_CREDENTIALS = true;

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <LanguageProvider>
        <FeatureFlagContextProvider>
          <AppContextProvider>
            <div className="flex min-h-screen flex-col">
              <Root />
            </div>
          </AppContextProvider>
        </FeatureFlagContextProvider>
      </LanguageProvider>
    </Router>
  </React.StrictMode>,
  MOUNT_NODE,
);
